import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

export const loadNewsletterData = createAsyncThunk(
    "newsletter/loadNewsletterData",
    async (_, { rejectWithValue }) => {
        try {
            const response = await agent.post(API.NEWSLETTER_DATA, {});
            return response.data.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to load newsletter"
            );
        }
    }
);

export const loadVideoData = createAsyncThunk(
    "videos/loadVideoData",
    async (_, { rejectWithValue }) => {
        try {
            const response = await agent.post(API.VIDEO_DATA, {});
            return response.data.data; // same as old code
        } catch (error) {
            return rejectWithValue( error.response?.data?.message || "Failed to load videos");
        }
    }
);

const newsletterSlice = createSlice({
    name: "newsletter",
    initialState: {
        NewsletterData: [],
        VideoData: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // same as loadNewsletterDataSuccess(true)
            .addCase(loadNewsletterData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            // same as loadNewsletterDataSuccess(response.data.data)
            .addCase(loadNewsletterData.fulfilled, (state, action) => {
                state.loading = false;
                state.NewsletterData = action.payload;
            })

            .addCase(loadNewsletterData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(loadVideoData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            // === loadVideoDataSuccess(response.data.data)
            .addCase(loadVideoData.fulfilled, (state, action) => {
                state.loading = false;
                state.VideoData = action.payload;
            })

            .addCase(loadVideoData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to load videos";
            });
    },
});

export default newsletterSlice.reducer;
